import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import moment from "moment";

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { filterErrorHandler } from "../../hoc/Shared/utility";
import SettlementListing from "./SettlementListing";
import SettlementCreate from "./SettlementCreate";
import TransactionDetails from "../Transaction/TransactionDetails";

import { getSettlementList } from "../../store/ducks/settlement/actions";

const initialFilteringState = {
    start_date: "",
    end_date: "",
    order_id: "",
    date: "",
    status: ""
};

class Settlement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            pageShow: "listing",
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: '',
            totalRecords: 0,
            searchValue: '',
            data: [],
            filterInput: initialFilteringState,
            detailsParam: {},
            permission: [],
            status: [
                {
                    "value": 0 // Pending
                },
                {
                    "value": 1 // Confirmed
                },
                {
                    "value": 2 // Rejected
                },
                {
                    "value": 3 // Processing
                }
            ]
        }
    }

    componentDidMount() {
        const data = this.fetchData();
        this.props.getSettlementList(data);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.permission.length === 0 && this.props.currentPermission !== undefined) {
            this.setState({ permission: this.props.currentPermission });
        }

        if (nextProps.settlement_list !== undefined && nextProps.settlement_list !== this.props.settlement_list) {
            if (nextProps.settlement_list.responseCode === 200 && nextProps.settlement_list.msgType === "success") {
                this.setState({
                    data: nextProps.settlement_list.data.result.row,
                    totalRecords: nextProps.settlement_list.data.result.pagination.total_record,
                    loading: false
                });
            }
            else {
                this.setState({
                    loading: false,
                    data: [],
                    totalRecords: 0
                }, () => {
                    filterErrorHandler(nextProps.settlement_list.message);
                });
            }
        }

        return true;
    }

    fetchData = () => {
        const listingArr = {};
        let availablePage = this.state.activePage;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage });
        }

        listingArr.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        Object.keys(this.state.filterInput).forEach((val) => {
            listingArr[val] = ((val === 'start_date' || val === 'end_date') && this.state.filterInput[val] !== '') ? moment(this.state.filterInput[val]).format("YYYY-MM-DD") : this.state.filterInput[val];
        });

        return listingArr;
    }

    onInputChange(event) {
        // console.log(event.target.id+' | '+event.target.value);
        let newFilter = Object.assign({}, this.state.filterInput);
        if (event.target.id === 'transaction_date') {
            const date = (event.target.value !== '') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
            newFilter['date'] = event.target.value;
        }
        else {
            newFilter[event.target.id] = event.target.value;
        }
        this.setState({
            filterInput: newFilter
        });
    }

    clearHandler = () => {
        let newFilter = initialFilteringState;
        this.setState({
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            searchValue: '',
            order: '',
            filterInput: newFilter,
            loading: true,
            data: [],
        }, () => {
            const listingArr = this.fetchData();
            this.props.getSettlementList(listingArr);
        });
    }

    refreshHandler = () => {
        this.setState({
            loading: true,
            data: [],
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            order: '',
        }, () => {
            const listingArr = this.fetchData();
            this.props.getSettlementList(listingArr);
        });
    }

    // go to transaction details
    detailsHandler = (e, id) => {
        // console.log('detailsHandler (transaction): ', id);
        e.preventDefault();
        this.setState({
            pageShow: 'details',
            detailsParam: {
                id: id
            }
        });
    }

    changePageHandler = (page) => {
        // console.log(page);
        this.setState({
            pageShow: page,
        });
    }

    datatablesChangeHandler = (val, act) => {
        // console.log('datatablesChangeHandler :'+val + ' | '+act);
        this.setState({
            [act]: (act === 'searchValue') ? val.target.value : val,
            loading: true,
            data: [],
        }, () => {
            const listingArr = this.fetchData();
            this.props.getSettlementList(listingArr);
        });
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = (order === "asc") ? true : false;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({
            order: orderArry,
            loading: true,
            data: [],
        }, () => {
            const listingArr = this.fetchData();
            this.props.getSettlementList(listingArr);
        });
    }

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit));
        return <span>{rowNumber}</span>;
    };

    render() {
        const { t } = this.props;
        const columns = [
            { text: t("global.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "60px", textAlign: "center" } },
            { text: t("settlement.order-id"), dataField: "order_id", sort: true, onSort: this.onSort, headerStyle: { width: "115px" } },
            { text: t("settlement.settlement-reference-code"), dataField: "settlement_reference_code", sort: true, onSort: this.onSort },
            { text: t("settlement.reference-code"), dataField: "reference_code", sort: true, onSort: this.onSort },
            { text: t("settlement.account"), dataField: "account", sort: true, onSort: this.onSort },
            { text: t("settlement.amount"), dataField: "amount", sort: true, onSort: this.onSort },
            { text: t("settlement.fees"), dataField: "fees", sort: false, onSort: this.onSort },
            { text: t("settlement.status"), dataField: "status", sort: true, onSort: this.onSort },
            { text: t('settlement.created-at'), dataField: "created_at", sort: true, onSort: this.onSort },
            { text: t('settlement.approved-at'), dataField: "approved_at", sort: true, onSort: this.onSort },
            { text: t("settlement.updated-by"), dataField: "updated_by", sort: false }
        ];
        let statusClass = {
            0: "primary",
            1: "success",
            2: "danger",
            3: "secondary",
            4: "danger",
        };

        let data = this.state.data.map((val, idx) => {
            const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
            let order_id = this.state.permission.includes(
                "transaction_details_access"
            ) ? (
                <b>
                    <a href="/#" onClick={(event) => this.detailsHandler(event, val.id)}>
                        {val.order_id}
                        <i className="fas fa-external-link-square-alt text-primary ml-1"></i>
                    </a>
                </b>
            ) : (
                val.order_id
            );
            let status = (
                <span className={`badge-${statusClass[val.status]}`}>
                    {t(`transaction.status-desc.${val.status}`)}
                </span>
            );

            return {
                no: idx,
                order_id: order_id,
                settlement_reference_code: val.settlement_reference_code,
                reference_code: val.reference_code,
                account: val.account,
                status: status,
                amount: new Intl.NumberFormat("en-US", num_format).format(val.amount),
                fees: new Intl.NumberFormat("en-US", num_format).format(val.fees),
                created_at: val.create_date,
                approved_at: val.approve_date ?? '-',
                updated_by: val.updated_by ?? '-'
            }
        });
        
        return (
            <Auxiliary>
                {this.state.pageShow === "listing" && (
                    <SettlementListing
                        filterInput={this.state.filterInput}
                        permission={this.state.permission}

                        changePageHandler={(page) => this.changePageHandler(page)}
                        clearHandler={() => this.clearHandler()}
                        refreshHandler={() => this.refreshHandler()}
                        detailsHandler={(event, id) => this.detailsHandler(event, id)}
                        onInputChange={(event) => this.onInputChange(event)}
                        datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                        onSort={(field, order) => this.onSort(field, order)}

                        data={data}
                        columns={columns}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        searchValue={this.state.searchValue}

                        loading={this.state.loading}
                        status={this.state.status}
                    />
                )}

                {this.state.pageShow === "details" && (
                    <TransactionDetails
                        detailsParam={this.state.detailsParam}
                        changePageHandler={(page) => this.changePageHandler(page)}
                        returnPage='listing'
                    />
                )}

                {this.state.permission.includes("settlement_create") && this.state.pageShow === 'create' && (
                    <SettlementCreate
                        changePageHandler={(page) => this.changePageHandler(page)}
                        refreshHandler={() => this.refreshHandler()}
                    />
                )}
            </Auxiliary>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentPermission: state.currentUser.data.permission,
        settlement_list: state.settlement.settlement_list
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getSettlementList: (data) => dispatch(getSettlementList(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(Settlement));